import React, { useEffect, useMemo, useState, useCallback } from "react";
import "../../styles/glass.css";
import "../../styles/globals.css";
import "../../styles/layout.css";
import "../styles/platform.css";
import "../styles/LeftSidebar.css";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import { platformMainPageContent } from "../data/platformMainPageContent";
import HeaderPlatform from "../components/HeaderPlatform";
import FooterPlatform from "../components/FooterPlatform";
import LeftSidebar from "../components/LeftSidebar";
import GlassCard from "../../components/GlassCard";
import BasicInfoBox from "../components/BasicInfoBox";
import NotificationBlock from "../components/NotificationBlock";
import { ExerciseBlock } from "../components/ExerciseBlock";
import TodayPlanCard from "../components/TodayPlanCard";
import BeforeForm from "../components/BeforeForm";
import { useAuth } from "../../auth";
import LoadingPage from "./LoadingPage";
import {
  fetchNotifications,
  deleteNotification,
  markNotificationAsRead,
} from "../api/notificationsApi";


export const PlatformMainPage = () => {
  const [exercises] = useState([
    {
      id: "ex-1",
      name: "Plank Hold",
      difficulty: "easy",
      inSession: false,
      muscles: ["Core", "Shoulders", "Glutes"],
      longDescription: "Long description from DB...",
      detailImages: ["/img/plank1.jpg", "/img/plank2.jpg"],
      detailMusclesImageUrl: "/img/muscles_core.png",
      detailYoutubeUrl: "https://www.youtube.com/watch?v=pSHjTRCQxIw",
      commonMistakes: [
        "Hips sagging toward the floor.",
        "Neck looking forward instead of down.",
      ],
    },
    {
      id: "ex-2",
      name: "Plank Hold",
      difficulty: "easy",
      inSession: false,
      muscles: ["Core", "Shoulders", "Glutes"],
      longDescription: "Long description from DB...",
      detailImages: ["/img/plank1.jpg", "/img/plank2.jpg"],
      detailMusclesImageUrl: "/img/muscles_core.png",
      detailYoutubeUrl: "https://www.youtube.com/watch?v=pSHjTRCQxIw",
      commonMistakes: [
        "Hips sagging toward the floor.",
        "Neck looking forward instead of down.",
      ],
    },
  ]);

  const [expandedId, setExpandedId] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const { user, loading: authLoading } = useAuth();
  const hasCompletedIntake = !!user?.completed_intake;

  const currentLang = useCurrentLang();
  const t = platformMainPageContent[currentLang] || platformMainPageContent.en;

  const handleToggleExpand = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  const handleCompleteExercise = (id) => {
    console.log("Exercise completed:", id);
  };

  async function loadNotifications() {
    try {
      setLoading(true);
      setError("");

      const data = await fetchNotifications();
      setNotifications(data);
    } catch (err) {
      setError(err.message || t.failedLoadNotifications);
    } finally {
      setLoading(false);
    }
  }

  async function handleDelete(id) {
    try {
      setError("");
      await deleteNotification(id);
      setNotifications((prev) => prev.filter((item) => item.id !== id));
    } catch (err) {
      setError(err.message || t.failedDeleteNotification);
    }
  }

  async function handleMarkAsRead(id) {
    try {
      const updated = await markNotificationAsRead(id);
      setNotifications((prev) =>
        prev.map((item) => (item.id === id ? updated : item))
      );
    } catch (err) {
      console.error("Failed to mark notification as read:", err);
    }
  }

  useEffect(() => {
    loadNotifications();
  }, []);

  const mappedNotifications = useMemo(() => {
    return notifications.map((notification) => ({
      id: notification.id,
      title: notification.title || t.notificationFallback,
      subject: notification.title || t.notificationFallback,
      date: notification.sent_at || notification.created_at,
      text: notification.message || "",
      is_read: notification.is_read,
    }));
  }, [notifications, t]);

  if (authLoading) {
    return <LoadingPage />;
  }

  return (
    <div className="revimo-layout">
      <HeaderPlatform />
      <main className="revimo-main">
        <LeftSidebar />
        <div className="revimo-page-content">
          {!hasCompletedIntake ? (
            <BeforeForm />
          ) : (
            <>
              <BasicInfoBox />

              <GlassCard
                style={{ marginLeft: "50px", marginTop: "25px", padding: "15px" }}
              >
                <div
                  style={{
                    fontSize: "0.8rem",
                    textTransform: "uppercase",
                    letterSpacing: "0.08em",
                    opacity: 0.7,
                  }}
                >
                  {t.notificationsLabel}
                </div>

                {loading && (
                  <div style={{ marginTop: "16px", opacity: 0.8 }}>
                    {t.loadingNotifications}
                  </div>
                )}

                {error && (
                  <div style={{ marginTop: "16px", color: "#ff6b6b" }}>
                    {error}
                  </div>
                )}

                {!loading && !error && mappedNotifications.length === 0 && (
                  <div style={{ marginTop: "16px", opacity: 0.8 }}>
                    {t.noNotifications}
                  </div>
                )}

                {!loading && !error && mappedNotifications.length > 0 && (
                  <NotificationBlock
                    notifications={mappedNotifications}
                    onDelete={handleDelete}
                    onNotificationClick={handleMarkAsRead}
                    l_m="0px"
                  />
                )}
              </GlassCard>

              <TodayPlanCard />

              <GlassCard
                style={{ marginLeft: "50px", marginTop: "25px", padding: "15px" }}
              >
                <div style={{ color: "#0b1720", fontWeight: "500" }}>
                  {t.unknownExercises}
                </div>

                {exercises.map((ex) => (
                  <ExerciseBlock
                    key={ex.id}
                    {...ex}
                    isExpanded={expandedId === ex.id}
                    onToggleExpand={handleToggleExpand}
                    onCompleteExercise={handleCompleteExercise}
                    l_m="0px"
                  />
                ))}
              </GlassCard>
            </>
          )}
        </div>
      </main>
      <footer className="revimo-footer">
        <FooterPlatform />
      </footer>
    </div>
  );
};


export default PlatformMainPage;